import { UploadModel } from '@sosocio/creator-types/app';
import { MIME_TYPES_REQUIRE_CONVERSION } from 'settings/filetypes';
import _ from 'underscore';
import { reactive } from 'vue';
import {
	Module,
	Mutation,
	VuexModule,
} from 'vuex-module-decorators';

@Module({
	namespaced: true,
	name: 'upload',
})
export default class Upload extends VuexModule {
	completed = reactive<UploadModel[]>([]);

	error = reactive<UploadModel[]>([]);

	uploading = reactive<UploadModel[]>([]);

	waiting = reactive<UploadModel[]>([]);

	get find() {
		return (id: string) => _.findWhere(
			this.error,
			{
				id,
			},
		)
			|| _.findWhere(
				this.uploading,
				{
					id,
				},
			)
			|| _.findWhere(
				this.waiting,
				{
					id,
				},
			)
			|| _.findWhere(
				this.completed,
				{
					id,
				},
			);
	}

	get findWhere() {
		return (props: Partial<UploadModel>) => _.findWhere(
			this.error,
			props,
		)
			|| _.findWhere(
				this.uploading,
				props,
			)
			|| _.findWhere(
				this.waiting,
				props,
			)
			|| _.findWhere(
				this.completed,
				props,
			);
	}

	get findCompleted() {
		return (id: string) => _.findWhere(
			this.completed,
			{
				id,
			},
		);
	}

	get findError() {
		return (id: string) => _.findWhere(
			this.error,
			{
				id,
			},
		);
	}

	get findUploading() {
		return (id: string) => _.findWhere(
			this.uploading,
			{
				id,
			},
		);
	}

	get findWaiting() {
		return (id: string) => _.findWhere(
			this.waiting,
			{
				id,
			},
		);
	}

	get getInProgress() {
		return _.union(
			this.uploading,
			this.waiting,
		);
	}

	get models() {
		return [
			...this.error,
			...this.uploading,
			...this.waiting,
			...this.completed,
		];
	}

	public get totalBytes() {
		let totalBytes = 0;
		this.getInProgress.forEach((uploadModel) => {
			totalBytes += uploadModel.totalBytes;
		});
		this.completed.forEach((uploadModel) => {
			totalBytes += uploadModel.totalBytes;
		});

		return totalBytes;
	}

	public get totalBytesSpecial() {
		let totalBytes = 0;
		this.getInProgress.forEach((uploadModel) => {
			if (uploadModel._type
				&& MIME_TYPES_REQUIRE_CONVERSION.includes(uploadModel._type)
			) {
				totalBytes += uploadModel.totalBytes;
			}
		});
		this.completed.forEach((uploadModel) => {
			if (uploadModel._type
				&& MIME_TYPES_REQUIRE_CONVERSION.includes(uploadModel._type)
			) {
				totalBytes += uploadModel.totalBytes;
			}
		});

		return totalBytes;
	}

	public get totalUploadBytes() {
		let totalUploadedBytes = 0;
		this.getInProgress.forEach((uploadModel) => {
			totalUploadedBytes += uploadModel.totalBytes * uploadModel.queue;
		});
		this.completed.forEach((uploadModel) => {
			totalUploadedBytes += uploadModel.totalBytes;
		});

		return totalUploadedBytes;
	}

	public get totalUploadBytesSpecial() {
		let totalUploadedBytes = 0;
		this.getInProgress.forEach((uploadModel) => {
			if (uploadModel._type
				&& MIME_TYPES_REQUIRE_CONVERSION.includes(uploadModel._type)
			) {
				totalUploadedBytes += uploadModel.totalBytes * uploadModel.queue;
			}
		});
		this.completed.forEach((uploadModel) => {
			if (uploadModel._type
				&& MIME_TYPES_REQUIRE_CONVERSION.includes(uploadModel._type)
			) {
				totalUploadedBytes += uploadModel.totalBytes;
			}
		});

		return totalUploadedBytes;
	}

	@Mutation
	public setProjection(projection: {
		waiting: UploadModel[];
		uploading: UploadModel[];
		error: UploadModel[];
		completed: UploadModel[];
	}) {
		this.waiting.splice(
			0,
			this.waiting.length,
			...projection.waiting,
		);
		this.uploading.splice(
			0,
			this.uploading.length,
			...projection.uploading,
		);
		this.error.splice(
			0,
			this.error.length,
			...projection.error,
		);
		this.completed.splice(
			0,
			this.completed.length,
			...projection.completed,
		);
	}
}
